// Types
import { CheckHandleOnBackHeaderType, HandleOnBackHeaderType } from 'types/app-back.type';

const handleOnBackHeader = ({
  initialState,
  state,
  setState,
  statesVisited,
  setStatesVisited,
  onBackClickHeader,
  onBackHeader,
  enumStates,
}: HandleOnBackHeaderType): void => {
  if (onBackClickHeader && !onBackHeader && state !== enumStates[initialState]) {
    statesVisited.pop();
    setStatesVisited(statesVisited);
    setState(enumStates[statesVisited[statesVisited.length - 1]]);
  }
};

const checkHandleOnBackHeader = ({
  enumStates,
  initialState,
  state,
  setState,
  statesVisited,
  onBackClickHeader,
  onBackHeader,
  setOnBackClickHeader,
  setOnBackHeader,
  setStatesVisited,
}:CheckHandleOnBackHeaderType): void => {
  setOnBackClickHeader(false);
  setStatesVisited([...statesVisited, state]);
  if (state !== initialState) {
    setOnBackHeader(true);
    handleOnBackHeader({
      enumStates,
      initialState,
      onBackClickHeader,
      onBackHeader,
      setState,
      state,
      statesVisited,
      setStatesVisited,
    });
  } else {
    setOnBackHeader(false);
  }
};

export { checkHandleOnBackHeader, handleOnBackHeader};
